var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../../di";
import { ProductInstancePurePriceService } from "./ProductInstancePurePriceService";
import { inject } from "tsyringe";
import { FulfillmentInstructionsToken, FulfillmentInstructions, } from "../FulfillmentInstructions";
let ProductInstancePriceService = class ProductInstancePriceService {
    constructor(productInstancePurePriceService, fulfillmentInstructions) {
        this.productInstancePurePriceService = productInstancePurePriceService;
        this.fulfillmentInstructions = fulfillmentInstructions;
        makeAutoObservable(this);
    }
    price(productInstance) {
        return this.productInstancePurePriceService.price(productInstance, this.fulfillmentInstructions.fulfillmentMethod);
    }
};
ProductInstancePriceService = __decorate([
    perRestaurant(),
    __param(1, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductInstancePurePriceService !== "undefined" && ProductInstancePurePriceService) === "function" ? _a : Object, typeof (_b = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _b : Object])
], ProductInstancePriceService);
export { ProductInstancePriceService };
